import React from 'react';
import { X } from 'lucide-react';

const ImageLightbox = ({ image, title, onClose }) => {
  if (!image) return null;
  
  return (
    <div 
      className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center p-4 cursor-pointer"
      onClick={onClose}
    >
      <button 
        onClick={onClose}
        className="absolute top-4 right-4 text-white hover:text-caramel transition-colors z-10"
      >
        <X className="w-8 h-8" />
      </button>
      <div className="relative max-w-4xl max-h-[90vh] w-full" onClick={(e) => e.stopPropagation()}>
        <img 
          src={image} 
          alt={title}
          className="w-full h-auto max-h-[85vh] object-contain rounded-lg shadow-2xl"
        />
        {title && (
          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4 rounded-b-lg">
            <h3 className="text-white text-xl font-bold text-center">{title}</h3>
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageLightbox;
